/* Gengar × Irezumi tiers on the app product page (#p/gengar-irezumi-collection).
   1. Maps the "Complete the theme" tiers to real variants on gengar-irezumi-collection
      (window.GMP[h].tv = tier index -> variant title regex), so checkout charges the tier price.
   2. Adds the free Gengar pack gifts per tier (G.gr: mats + Haunted Set get the freshener, Final Evolution
      gets freshener + jet tag) when they go to checkout from the app; the "Gengar pack gift" automatic discounts make them free. */
(()=>{
  const H = "gengar-irezumi-collection";
  const G = window.GMP && window.GMP[H];
  if (!G) return;
  let P = null;
  const ready = fetch("/products/" + H + ".js").then(r => r.ok ? r.json() : null).then(p => { P = p; }).catch(() => {});
  const idx = t => {
    if (!P || !G.tv || !G.tv[t]) return -1;
    const re = new RegExp(G.tv[t], "i");
    return P.variants.findIndex(v => re.test(v.title) && v.available);
  };

  /* runs after mockup-bridge.js has tagged the line with its key {m, mk, t, mi} */
  const wrap = () => {
    const X = window.CARTX;
    if (!X || !X.__w) return false;
    if (X.__g) return true;
    X.__g = 1;
    const orig = X.named;
    X.named = function (n) {
      const r = orig.apply(this, arguments);
      try {
        const l = X.S().l.slice().reverse().find(x => x.n === n);
        if (l && l.k && l.k.m === H && l.k.t) {
          const i = idx(l.k.t);
          if (i >= 0) l.k = { m: H, mk: l.k.mk, t: 0, mi: i };
        }
      } catch (e) {}
      return r;
    };
    return true;
  };
  const iv = setInterval(() => { if (wrap()) clearInterval(iv); }, 250);
  setTimeout(() => clearInterval(iv), 20000);

  /* pack gifts at checkout: G.gr = [[variant title regex, [gift variant ids]], ...], first match wins */
  const GR = (G.gr || []).map(([re, ids]) => [new RegExp(re, "i"), ids.map(Number)]);
  const allGifts = [...new Set(GR.flatMap(x => x[1]))];
  const giftsFor = id => {
    const v = P && P.variants.find(v => v.id == id);
    if (!v) return [];
    const hit = GR.find(([re]) => re.test(v.title));
    return hit ? hit[1] : [];
  };
  const of = window.fetch;
  window.fetch = async function (u, o) {
    try {
      if (GR.length && typeof u === "string" && /\/cart\/add\.js/.test(u) && o && typeof o.body === "string") {
        await ready;
        const b = JSON.parse(o.body);
        if (b && Array.isArray(b.items) && !b.items.some(i => allGifts.includes(+i.id))) {
          const want = [...new Set(b.items.flatMap(i => giftsFor(i.id)))];
          if (want.length) {
            const cur = await of.call(window, "/cart.js").then(r => r.json()).catch(() => null);
            const have = new Set(((cur && cur.items) || []).filter(it => !(it.properties && it.properties._src === "app")).map(it => +it.variant_id));
            want.filter(id => !have.has(id)).forEach(id => b.items.push({ id, quantity: 1, properties: { _src: "app" } }));
            o = Object.assign({}, o, { body: JSON.stringify(b) });
          }
        }
      }
    } catch (e) {}
    return of.call(window, u, o);
  };
})();
